import React, { useState, useEffect, useRef } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import { Link, useLocation, useParams } from "react-router-dom";
import { CHATROOMVIEW } from "common/viewContent";
import BackButtom from "components/BackButtom";
import { getSocket } from "helpers/socket";
import { getMessageList } from "store/actions";
import { addMessage } from "store/chatRoom/slice";
import { uploadFile } from "store/actions";
import styled from "styled-components";

const ChatRoomDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  // const [data, setData] = useState(location?.state?.summary || {});
  const [data, setData] = useState(() => {
    const stateSummary = location?.state?.summary;
    if (stateSummary) {
      return stateSummary;
    }
    const localSummary = localStorage.getItem("summary");
    return localSummary ? JSON.parse(localSummary) : {};
  });
  const { MESSAGES } = useSelector((state) => state.ChatRoom);
  const { user } = useSelector((state) => state.Auth);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);
  const socket = getSocket();
  console.log(file, "data");
  console.log(user, "MESSAGES", MESSAGES);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      setFileType(null);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    if (file.type.startsWith("image/")) {
      setFileType("image");
    } else if (file.type.startsWith("video/")) {
      setFileType("video");
    } else {
      setFileType(null); // unsupported type
    }

    // Cleanup to avoid memory leaks
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  useEffect(() => {
    if (!socket) return;
    socket.emit("joinGroup", { chatRoomId: data.id }, (acknowledgement) => {
      console.log("✅ Joined group:", acknowledgement);
    });
    return () => {
      socket.emit("leaveGroup", { chatRoomId: data.id }, (acknowledgement) => {
        console.log("✅ Leave group:", acknowledgement);
      });
    };
  }, [location.pathname, socket]);

  useEffect(() => {
    if (!socket) return;

    const handleGroupMessage = (newMessage) => {
      console.log("Received message:", newMessage);
      dispatch(addMessage(newMessage));
      //setMessageList((prevMessages) => [...prevMessages, newMessage]);
    };

    socket.on("groupChatMessage", handleGroupMessage);

    return () => {
      socket.off("groupChatMessage", handleGroupMessage); // cleanup on unmount
    };
  }, [socket]);

  const fetchData = async () => {
    const payload = {
      chatRoomId: data.id,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          //setDoctor(res);
        }
      };
      dispatch(
        getMessageList({
          data: payload,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    fetchData();
  }, [data]);

  const upload = () => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve(null); // No file to upload

      const callback = (err, res) => {
        console.log(err, res, "<===err, res");
        if (err) {
          toast.error("Something went wrong on file upload!");
          reject(err);
        } else {
          resolve(res);
        }
      };

      dispatch(uploadFile({ data: file, callback }));
    });
  };
  const handleSendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    let fileUrl = null;
    let fileType = file?.type;

    try {
      fileUrl = await upload();
    } catch (error) {
      console.error("File upload failed", error);
      setLoading(true);
      return;
    }

    const payload = {
      msg: message,
      userId: user.id,
      username: "MSH Admin",
      fileUrl,
      fileType,
      chatRoomId: data.id,
    };

    socket.emit("groupChat", payload);

    setMessage("");
    setFile(null);
    setPreview(null);
    setFileType(null);
    setLoading(false);
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [MESSAGES]);

  const renderMessageWithLinks = (text, from) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <RenderLink
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className={`${
            from == "me" ? "Melink" : "themeClr"
          } underline text-break `}
          style={{ textDecoration: "underline" }}
        >
          {part}
        </RenderLink>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  };
  const handleRemove = () => {
    setFile(null);
    setPreview(null);
    setFileType(null);
  };

  return (
    <>
      {/* {data === "true" && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )} */}
      <Helmet title={CHATROOMVIEW.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <BackButtom />
          <h1>{CHATROOMVIEW.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.chatRoom}>Chat Room</Link>
            </div>
            <div className="breadcrumb-item">{CHATROOMVIEW.CURRENT_MODULE}</div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{CHATROOMVIEW.TOP_CONTENT}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Chat user-chat-show">
        <div className="ChatHead py-2 border-bottom">
          <div className="d-block d-lg-none">
            <a
              className=" user-chat-remove"
              href="/doctor/cardiovascularcommunity"
            >
              <i className="fa-solid fa-angle-left" />
            </a>
          </div>
          <li className="group w-100">
            <p className="GroupName">{data.name}</p>
            <a
              className="avatar user-chat-remove"
              //href="/doctor/cardiovascularcommunity"
            >
              <img src={data.image} alt="image" />
            </a>
          </li>
        </div>
        <div className="MessageContainer" id="chatElement">
          <span />
          {MESSAGES?.map((val, index) => {
            const isImage = val?.fileType?.startsWith("image/");
            return (
              <>
                {val?.userId === user?.id ? (
                  <div className="py-1">
                    <div className="messageDetails justify-content-center">
                      <div className="messageTime text-muted">
                        {new Date(val.createdAt).toLocaleDateString([], {
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    </div>
                    <div className="message me" key={index}>
                      <p
                        className="messageContent text-white text-start"
                        style={{ fontSize: 12 }}
                      >
                        You ~
                      </p>
                      <div
                        className={`${val?.fileUrl && "video-card"}`}
                        style={{
                          width: val?.fileUrl && 250,
                          background: val?.fileUrl && "#2266b3",
                        }}
                      >
                        {val?.fileUrl &&
                          (isImage ? (
                            <img
                              src={val?.fileUrl}
                              alt=""
                              className="img-fluid rounded w-100 object-fit-contain"
                              style={{ maxHeight: 280 }}
                            />
                          ) : (
                            <video
                              key={val?.id}
                              src={val?.fileUrl}
                              className="img-fluid rounded w-100 object-fit-contain"
                              style={{ height: 280 }}
                              controls
                            />
                          ))}
                        {/* <p className="messageContent text-white"> */}
                        <p className="m-0 title text-white text-start">
                          {renderMessageWithLinks(val.msg, "me")}
                        </p>
                      </div>
                    </div>
                    <div className="messageDetails">
                      <div className="messageTime text-muted pr-1">
                        {new Date(val.createdAt)
                          .toLocaleTimeString([], {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          })
                          .replace(/ AM| PM/, "")}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="py-1">
                      <div className="messageDetails justify-content-center">
                        <div className="messageTime text-muted mx-auto">
                          {new Date(val.createdAt).toLocaleDateString([], {
                            weekday: "short",
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </div>
                      </div>
                      <div className="message you" key={index}>
                        <p
                          className="messageContent text-primary"
                          style={{ fontSize: 12 }}
                        >
                          ~{val?.username}
                        </p>
                        <div
                          className={`${val?.fileUrl && "video-card"}`}
                          style={{ width: val?.fileUrl && 250 }}
                        >
                          {val?.fileUrl &&
                            (isImage ? (
                              <img
                                src={val?.fileUrl}
                                alt=""
                                className="img-fluid rounded w-100 object-fit-contain"
                                style={{ maxHeight: 280 }}
                              />
                            ) : (
                              <video
                                key={val?.id}
                                src={val?.fileUrl}
                                className="img-fluid rounded w-100 object-fit-contain"
                                style={{ height: 280 }}
                                controls
                              />
                            ))}
                          {/* <p className="messageContent"> */}
                          <p className="m-0 title">
                            {renderMessageWithLinks(val.msg, "you")}
                          </p>
                        </div>
                      </div>
                      <div className="messageDetails">
                        <div className="messageTime text-muted pl-1">
                          {new Date(val?.createdAt)
                            .toLocaleTimeString([], {
                              hour: "numeric",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(/ AM| PM/, "")}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            );
          })}
          {MESSAGES.length === 0 && (
            <div className="h-100 d-flex align-items-center justify-content-center">
              <p className="m-0 text-dark fw-bold py-2">No messages yet</p>
            </div>
          )}
          <div ref={bottomRef} />
        </div>
        <form
          id="MessageForm"
          className="flex-wrap"
          onSubmit={handleSendMessage}
        >
          {preview && (
            <div
              className="bg-white border p-2 d-flex w-100"
              style={{ gap: 10 }}
            >
              <div className="position-relative">
                <button
                  className="position-absolute text-danger border-0 p-0"
                  disabled={loading}
                  style={{
                    top: -8,
                    right: -10,
                    zIndex: 9,
                    background: "#fff",
                    padding: 0,
                    fontSize: 0,
                    lineHeight: 0,
                    margin: 0,
                    height: 17,
                    width: 20,
                  }}
                  type="button"
                  onClick={handleRemove}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 0C3.1 0 0 3.1 0 7C0 10.9 3.1 14 7 14C10.9 14 14 10.9 14 7C14 3.1 10.9 0 7 0ZM9.7 10.5L7 7.8L4.3 10.5L3.5 9.7L6.2 7L3.5 4.3L4.3 3.5L7 6.2L9.7 3.5L10.5 4.3L7.8 7L10.5 9.7L9.7 10.5Z"
                      fill="#E60404"
                    />
                  </svg>
                </button>
                {loading && (
                  <img
                    src="/assets/images/loading.gif"
                    alt="Loading"
                    style={{
                      height: 40,
                      top: "50%",
                      transform: "translateY(-50%)",
                      right: 0,
                      left: 0,
                    }}
                    className="img-fluid object-fit-contain position-absolute mx-auto"
                    referrerPolicy="no-referrer"
                  />
                )}
                {preview && fileType === "image" && (
                  <img
                    src={preview}
                    style={{ height: 70, width: 70 }}
                    alt=""
                    className="img-fluid rounded object-fit-over"
                  />
                )}
                {preview && fileType === "video" && (
                  <video
                    key={preview}
                    src={preview}
                    className="img-fluid rounded object-fit-contain"
                    style={{ maxWidth: 240, maxHeight: 240 }}
                    controls
                  />
                )}
              </div>
            </div>
          )}
          <div className="chat-input-group">
            <input
              type="text"
              placeholder="Enter Message..."
              id="MessageInput"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  if (message.trim() || file) {
                    handleSendMessage(e);
                  }
                }
              }}
            />
            <span className="input-group-text p-0 ms-2" id="basic-addon2">
              <label htmlFor="formFile" className="form-label mb-0">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3232 8.43602L9.49421 12.19C9.13021 12.55 8.93021 13.042 8.93821 13.559C8.94912 14.082 9.16451 14.5799 9.53821 14.946C9.91321 15.317 10.4182 15.53 10.9412 15.539C11.1972 15.5444 11.4518 15.4985 11.6898 15.4041C11.9278 15.3096 12.1445 15.1685 12.3272 14.989L16.1552 11.235C16.5163 10.8778 16.8011 10.4508 16.9923 9.98018C17.1834 9.50952 17.277 9.00492 17.2672 8.49702C17.2462 7.45094 16.8161 6.45474 16.0692 5.72202C15.3202 4.98088 14.3147 4.55653 13.2612 4.53702C12.7497 4.52681 12.2413 4.61865 11.7657 4.80718C11.2901 4.99571 10.8568 5.27714 10.4912 5.63502L6.66021 9.39002C6.11891 9.92618 5.69207 10.5666 5.40553 11.2726C5.11899 11.9785 4.97872 12.7353 4.99321 13.497C5.02541 15.0658 5.67085 16.5595 6.79121 17.658C7.91406 18.7695 9.42159 19.4061 11.0012 19.436C11.7688 19.452 12.5318 19.3147 13.2456 19.032C13.9594 18.7494 14.6097 18.3271 15.1582 17.79L18.9872 14.034"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </label>
              <input
                className="form-control d-none"
                type="file"
                id="formFile"
                onChange={(e) => setFile(e.target.files[0])}
                u
              />
            </span>
          </div>
          <button
            className="Send"
            type="submit"
            disabled={loading || (!message.trim() && !file)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.0396 2.32295C21.0556 1.96795 22.0316 2.94395 21.6766 3.95995L15.7516 20.89C15.3666 21.988 13.8366 22.05 13.3646 20.987L10.5056 14.555L14.5296 10.53C14.6621 10.3878 14.7342 10.1997 14.7308 10.0054C14.7274 9.81113 14.6486 9.62574 14.5112 9.48833C14.3738 9.35092 14.1884 9.27221 13.9941 9.26878C13.7998 9.26535 13.6118 9.33747 13.4696 9.46995L9.44461 13.494L3.01261 10.635C1.94961 10.162 2.01261 8.63295 3.10961 8.24795L20.0396 2.32295Z"
                fill="white"
              />
            </svg>
          </button>
        </form>
      </section>
    </>
  );
};

const RenderLink = styled.a`
  &.Melink {
    transition: 0.4s;
    &:hover {
      color: #fff;
    }
  }
`;

export default ChatRoomDetail;
